import React from "react"

function FieldValidation(props) {
  return (
    <div
      style={{
        fontSize: "12px",
        color: "rgb(244, 67, 54)",
      }}
    >
      {props.errorMessage}
    </div>
  )
}

export default FieldValidation
